import React, { Fragment } from 'react';
import RejectStoreModalContainer from '../brand/common/modal/RejectStoreModalContainer';
import RejectRegistrationStoreTagModalContainer from '../brand/common/modal/RejectRegistrationStoreTagModalContainer';
import PreviewExposureEventModalContainer from '../event/common/modal/PreviewExposureEventModalContainer';
import PreviewEventModalContainer from '../event/common/modal/PreviewEventModalContainer';
import SearchHomeModalContainer from '../widget/common/modal/SearchHomeModalContainer';
import ImgViewModalContainer from './common/modal/ImgViewModalContainer';
import VideoUploadModalContainer from './common/modal/VideoUploadModalContainer';
import VideoViewModalContainer from './common/modal/VideoViewModalContainer';
import PreviewProductDetailModalContainer from './common/modal/PreviewProductDetailModalContainer';
import PreviewTagDetailModalContainer from './common/modal/PreviewTagDetailModalContainer';
import TagListViewModalContainer from './common/modal/TagListViewModalContainer';
import RejectProductContainer from '../product/common/modal/RejectRegistrationProductModalContainer';
import RejectRegistrationProductPropertyModalContainer from '../product/common/modal/RejectRegistrationProductPropertyModalContainer';
import BanProductContainer from '../product/common/modal/RejectBanProductModalContainer';
import RejectReasonListModalContainer from '../product/common/modal/RejectReasonListModalContainer';
import DeleteProductModalContainer from '../product/common/modal/DeleteProductModalContainer';
import ExcelBulkEditProductDiscountModalContainer from '../product/common/modal/ExcelBulkEditProductDiscountModalContainer';
import ExcelBulkEditProductDiscountSuccessModalContainer from '../product/common/modal/ExcelBulkEditProductDiscountSuccessModalContainer';
import ExcelBulkEditProductDiscountFailModalContainer from '../product/common/modal/ExcelBulkEditProductDiscountFailModalContainer';
import DeliveryTrackingModalContainer from './common/modal/DeliveryTrackingModalContainer';
import OrderModifyDeliveryInfoModalContainer from './common/modal/OrderModifyDeliveryInfoModalContainer';
import OrderItemStatusChangeModalContainer from '../order/common/modal/OrderItemStatusChangeModalContainer';
import SendMessageServiceModalContainer from './common/modal/SendMessageServiceModalContainer';
import SearchCouponListModalContainer from '../coupon/common/modal/SearchCouponListModalContainer';
import CouponDetailModalContainer from '../coupon/common/modal/CouponDetailModalContainer';
import ExcelBulkGenerateCouponModalContainer from '../coupon/common/modal/ExcelBulkGenerateCouponModalContainer';
import PointLogModalContainer from '../point/common/PointLogModalContainer';
import ExcelBulkGeneratePointModalContainer from '../point/common/ExcelBulkGeneratePointModalContainer';
import NoticeProductItemListModalContainer from './common/modal/NoticeProductItemListModalContainer';
import CsInquiryQuestionModalContainer from '../cs/inquiry/common/modal/CsInquiryQuestionModalContainer';
import CsQnaQuestionModalContainer from '../cs/qna/common/modal/CsQnaQuestionModalContainer';
import EventItemListModalContainer from './common/modal/EventItemListModalContainer';
import WidgetLayoutManualModalContainer from '../widget/common/modal/WidgetLayoutManualModalContainer';
import WidgetPreviewModalContainer from '../widget/common/modal/WidgetPreviewModalContainer';
import WidgetPreviewPeriodModalContainer from '../widget/common/modal/WidgetPreviewCompareModalContainer';
import SearchStoreModalContainer from '../widget/common/modal/SearchStoreModalContainer';
import SearchEventModalContainer from '../widget/common/modal/SearchEventModalContainer';
import SearchProductModalContainer from '../widget/common/modal/SearchProductModalContainer';
import SearchInactiveWidgetModalContainer from '../widget/common/modal/SearchInactiveWidgetModalContainer';
import SearchReviewModalContainer from '../widget/common/modal/SearchReviewModalContainer';
import SearchTagModalContainer from '../widget/common/modal/SearchTagModalContainer';
import PreviewTagTabMainModalContainer from '../tag/common/modal/PreviewTagTabMainModalContainer';
import EditTagTabMainModalContainer from '../tag/common/modal/EditTagTabMainModalContainer';
import PreviewTagTrendKeywordModalContainer from '../tag/common/modal/PreviewTagTrendKeywordModalContainer';
import EditTagTrendKeywordModalContainer from '../tag/common/modal/EditTagTrendKeywordModalContainer';
import TagRejectModalContainer from './common/modal/TagRejectModalContainer';
import ReturnExchangeReasonModalContainer from './common/modal/ReturnExchangeReasonModalContainer';
import GenerateCouponValidSuccessModalContainer from './common/modal/GenerateCouponValidSuccessModalContainer';
import GenerateCouponValidFailModalContainer from './common/modal/GenerateCouponValidFailModalContainer';
import EditCouponDiscountModalContainer from '../coupon/common/modal/EditCouponDiscountModalContainer';
import CouponApplyAvailableProductListModalContainer from '../coupon/common/modal/CouponApplyAvailableProductListModalContainer';
import BrandProductListModalContainer from './common/modal/BrandProductListModalContainer';
import ExcelUploadCouponProductValidFailModalContainer from '../coupon/common/modal/ExcelUploadCouponProductValidFailModalContainer';
import ExcelUploadCouponProductValidSuccessModalContainer from '../coupon/common/modal/ExcelUploadCouponProductValidSuccessModalContainer';
import ExcelUploadCouponBrandValidFailModalContainer from '../coupon/common/modal/ExcelUploadCouponBrandValidFailModalContainer';
import ExcelUploadCouponBrandValidSuccessModalContainer from '../coupon/common/modal/ExcelUploadCouponBrandValidSuccessModalContainer';
import GeneratePointValidSuccessModalContainer from './common/modal/GeneratePointValidSuccessModalContainer';
import GeneratePointValidFailModalContainer from './common/modal/GeneratePointValidFailModalContainer';
import AccountUserDetailTagLogModalContainer from '../account/user/common/modal/AccountUserDetailTagLogModalContainer';
import ProductSubCategoryListViewModalContainer from '../app/common/modal/ProductSubCategoryListViewModalContainer';
import BuyerPurchaseHistoryModalContainer from './common/modal/BuyerPurchaseHistoryModalContainer';
import CheckDeliveryDispatchResultModalContainer from '../order/common/modal/CheckDeliveryDispatchResultModalContainer';
import CheckExcelBulkDeliveryDispatchResultModalContainer from '../order/common/modal/CheckExcelBulkDeliveryDispatchResultModalContainer';
import DeliveryDelayModalContainer from '../order/common/modal/DeliveryDelayModalContainer';
import ExcelBulkDeliveryDispatchModalContainer from '../order/common/modal/ExcelBulkDeliveryDispatchModalContainer';
import CancelSalesModalContainer from '../order/common/modal/CancelSalesModalContainer';
import EditBuyerInfoModalContainer from '../order/common/modal/EditBuyerInfoModalContainer';
import CancelSalesConfirmModalContainer from '../order/common/modal/CancelSalesConfirmModalContainer';
import RejectCancelModalContainer from '../order/common/modal/RejectCancelModalContainer';
import CancelCompleteConfirmModalContainer from '../order/common/modal/CancelCompleteConfirmModalContainer';
import RejectCancelDeliveryDispatchModalContainer from '../order/common/modal/RejectCancelDeliveryDispatchModalContainer';
import RejectReturnModalContainer from '../order/common/modal/RejectReturnModalContainer';
import EditReturnReasonModalContainer from '../order/common/modal/EditReturnReasonModalContainer';
import ReturnReasonModalContainer from '../order/common/modal/ReturnReasonModalContainer';
import CompleteReturnModalContainer from '../order/common/modal/CompleteReturnModalContainer';
import ExchangeReasonModalContainer from '../order/common/modal/ExchangeReasonModalContainer';
import EditExchangeReasonModalContainer from '../order/common/modal/EditExchangeReasonModalContainer';
import RejectExchangeModalContainer from '../order/common/modal/RejectExchangeModalContainer';
import EditExchangeDeliveryInfoModalContainer from '../order/common/modal/EditExchangeDeliveryInfoModalContainer';
import CompleteExchangeModalContainer from '../order/common/modal/CompleteExchangeModalContainer';
import OrderItemReturnExchangeRequestModalContainer from '../order/common/modal/OrderItemReturnExchangeRequestModalContainer';
import ProductPayMethodTypeEditConfirmModalContainer from '../product/common/modal/ProductPayMethodTypeEditConfirmModalContainer';
import SearchProductCategoryModalContainer from '../app/common/modal/SearchProductCategoryModalContainer';

const ModalContainerList = () => {
  return (
    <Fragment>
      {/*유저 태그 타임라인 리스트 모달*/}
      <AccountUserDetailTagLogModalContainer />

      {/*판매점 승인 거절 모달*/}
      <RejectStoreModalContainer />
      {/*판매점 태그 승인 거절 모달*/}
      <RejectRegistrationStoreTagModalContainer />

      {/*태그 거절 모달*/}
      <TagRejectModalContainer />

      {/* 이미지 보기 모달 */}
      <ImgViewModalContainer />
      {/* 영상 업로드 모달 */}
      <VideoUploadModalContainer />
      {/* 영상 미리 보기 모달 */}
      <VideoViewModalContainer />
      {/* 상품 상세 미리보기 */}
      <PreviewProductDetailModalContainer />
      {/*태그 미리보기 모달*/}
      <PreviewTagDetailModalContainer />
      {/* 태그 리스트 보기 모달 */}
      <TagListViewModalContainer />
      {/* 브랜드 상품 리스트 모달 */}
      <BrandProductListModalContainer />
      {/* 아이템 검색 모달 */}
      <SearchProductCategoryModalContainer />

      {/* 기획전 아이템 리스트 모달 */}
      <EventItemListModalContainer />

      {/* 기획전 미리 보기 모달*/}
      <PreviewEventModalContainer />

      {/* 상품 승인 거절 모달 */}
      <RejectProductContainer />
      {/* 상품 속성 승인 거절 모달 */}
      <RejectRegistrationProductPropertyModalContainer />
      {/* 상품 판매 금지 모달 */}
      <BanProductContainer />
      {/* 거절 사유 리스트 모달 */}
      <RejectReasonListModalContainer />
      {/* 상품 삭제 모달*/}
      <DeleteProductModalContainer />
      {/*상품 할인 일괄변경 모달*/}
      <ExcelBulkEditProductDiscountModalContainer />
      {/*상품 할인 일괄변경 성공 모달*/}
      <ExcelBulkEditProductDiscountSuccessModalContainer />
      {/*상품 할인 일괄변경 실패 모달*/}
      <ExcelBulkEditProductDiscountFailModalContainer />
      {/*2차 카테고리 보기 모달*/}
      <ProductSubCategoryListViewModalContainer />
      {/*상품 결제 타입 편집 검증 모달*/}
      <ProductPayMethodTypeEditConfirmModalContainer />

      {/* 배송 조회 모달  */}
      <DeliveryTrackingModalContainer />
      {/* 배송지 변경 이력 조회 모달  */}
      <OrderModifyDeliveryInfoModalContainer />
      {/*주문 상태 되돌리기 모달*/}
      <OrderItemStatusChangeModalContainer />
      {/* 문자 발송 모달  */}
      <SendMessageServiceModalContainer />
      {/* 구매자 이전 구매내역 조회 모달 */}
      <BuyerPurchaseHistoryModalContainer />
      {/*배송 지연처리 모달*/}
      <DeliveryDelayModalContainer />
      {/*발송 처리 유효성 체크 결과 모달*/}
      <CheckDeliveryDispatchResultModalContainer />
      {/*엑셀 일괄 발송 처리 유효성 체크 결과 모달*/}
      <CheckExcelBulkDeliveryDispatchResultModalContainer />
      {/*엑셀 일괄 배송 모달*/}
      <ExcelBulkDeliveryDispatchModalContainer />
      {/*판매 취소 모달*/}
      <CancelSalesModalContainer />
      {/*주문자 정보 수정 모달*/}
      <EditBuyerInfoModalContainer />
      {/*판매 취소전 재고/상품상태 설정 모달*/}
      <CancelSalesConfirmModalContainer />
      {/*취소 거부 모달*/}
      <RejectCancelModalContainer />
      {/*취소 완료전 재고/상품상태 설정 모달*/}
      <CancelCompleteConfirmModalContainer />
      {/*취소 거부 -> 발송 처리*/}
      <RejectCancelDeliveryDispatchModalContainer />
      {/*반품거절 모달*/}
      <RejectReturnModalContainer />
      {/*반품 사유 수정 모달*/}
      <EditReturnReasonModalContainer />
      {/*반품 승인 처리 모달*/}
      <CompleteReturnModalContainer />
      {/*반품 요청 또는 반품 검부 사유 모달*/}
      <ReturnReasonModalContainer />
      {/*교환 거절 모달*/}
      <RejectExchangeModalContainer />
      {/*교환 사유 수정 모달*/}
      <EditExchangeReasonModalContainer />
      {/*교환 재배송 송장 수정 모달*/}
      <EditExchangeDeliveryInfoModalContainer />
      {/*교환 완료 모달*/}
      <CompleteExchangeModalContainer />
      {/*교환 요청 또는 교환 검부 사유 모달*/}
      <ExchangeReasonModalContainer />
      {/*교환/반품으로 변경 모달*/}
      <OrderItemReturnExchangeRequestModalContainer />

      {/*쿠폰 할인 편집 모달*/}
      <EditCouponDiscountModalContainer />
      {/*쿠폰 상세 보는 모달*/}
      <CouponDetailModalContainer />
      {/*발급할 쿠폰 검색 모달*/}
      <SearchCouponListModalContainer />
      {/*쿠폰 발급 유효성 검사 성공 모달*/}
      <GenerateCouponValidSuccessModalContainer />
      {/*쿠폰 발급 유효성 검사 실패 모달*/}
      <GenerateCouponValidFailModalContainer />
      {/*쿠폰 사용 가능한 상품 유효성 검사 성공 모달*/}
      <ExcelUploadCouponProductValidSuccessModalContainer />
      {/*쿠폰 사용 가능한 상품 유효성 검사 실패 모달*/}
      <ExcelUploadCouponProductValidFailModalContainer />
      {/*쿠폰 사용 가능한 브랜드 유효성 검사 성공 모달*/}
      <ExcelUploadCouponBrandValidSuccessModalContainer />
      {/*쿠폰 사용 가능한 브랜드 유효성 검사 실패 모달*/}
      <ExcelUploadCouponBrandValidFailModalContainer />
      {/*쿠폰 일괄 발급 모달*/}
      <ExcelBulkGenerateCouponModalContainer />
      {/*쿠폰적용가능 상품 리스트 모달*/}
      <CouponApplyAvailableProductListModalContainer />

      {/*포인트 로그 조회 모달*/}
      <PointLogModalContainer />
      {/*포인트 발급 유효성 검사 성공 모달*/}
      <GeneratePointValidSuccessModalContainer />
      {/*포인트 발급 유효성 실패 성공 모달*/}
      <GeneratePointValidFailModalContainer />
      {/*포인트 일괄 발급 엑셀 업로드 모달*/}
      <ExcelBulkGeneratePointModalContainer />

      {/*상품 공지사항 아이템 리스트 모달 */}
      <NoticeProductItemListModalContainer />

      {/*1:1 문의 질문 내용 조회 모달*/}
      <CsInquiryQuestionModalContainer />

      {/*상품 문의 질문 내용 조회 모달*/}
      <CsQnaQuestionModalContainer />
      {/*위젯 레이아웃 모달*/}
      <WidgetLayoutManualModalContainer />
      {/*위젯 미리보기 모달*/}
      <WidgetPreviewModalContainer />
      {/*기간에 따른 위젯 미리보기 모달*/}
      <WidgetPreviewPeriodModalContainer />
      {/* 브랜드 리스트 검색 모달 */}
      <SearchStoreModalContainer />
      {/* 기획전 리스트 검색 모달 */}
      <SearchEventModalContainer />
      {/* 홈 페이지 리스트 검색 모달 */}
      <SearchHomeModalContainer />
      {/* 상품 리스트 검색 모달 */}
      <SearchProductModalContainer />
      {/* 후기 리스트 검색 모달 */}
      <SearchReviewModalContainer />
      {/* 테그 리스트 검색 모달 */}
      <SearchTagModalContainer />
      {/* 비활성 중인 위젯 리스트 검색 모달 */}
      <SearchInactiveWidgetModalContainer />
      {/* 위젯에 노출중인 기획전 미리 보기 모달*/}
      <PreviewExposureEventModalContainer />

      {/* 태그 탭 메인 미리보기 모달 */}
      <PreviewTagTabMainModalContainer />
      {/* 태그 탭 메인 편집하기 모달 */}
      <EditTagTabMainModalContainer />
      {/* 태그 트렌드 키워드 미리보기 모달 */}
      <PreviewTagTrendKeywordModalContainer />
      {/* 태그 트렌드 키워드 편집하기 모달 */}
      <EditTagTrendKeywordModalContainer />

      {/*반품, 교환 요청사유, 거부사유 모달*/}
      <ReturnExchangeReasonModalContainer />
    </Fragment>
  );
};

export default ModalContainerList;
